module.exports = __webpack_public_path__ + "img/Uruguay.9eb65148.png";